/**
 * Which row actions to show for an order line item (web + mobile orders).
 * Keep a single source of truth so product-card buttons stay in sync.
 */
export function getOrderItemVisibleOptions(orderItem) {
    const itemStatusNorm = (orderItem.itemStatus || '').toString().trim().toLowerCase();
    if (itemStatusNorm === 'cancelled') return [];
    if (itemStatusNorm === 'processing') return ['cancel', 'track'];
    if (itemStatusNorm === 'shipped') return ['cancel', 'track', 'review'];
    if (itemStatusNorm === 'ontheway') return ['track', 'cancel'];
    if (itemStatusNorm === 'delivered') {
        return orderItem.hasReviewed
            ? ['track', 'view-review', 'cancel']
            : ['track', 'review', 'cancel'];
    }
    if (itemStatusNorm === 'returned') {
        return orderItem.hasReviewed
            ? ['track', 'view-review', 'cancel']
            : ['track', 'review', 'cancel'];
    }
    return ['cancel', 'track'];
}
